"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDraggable = void 0;
var react_1 = require("react");
var eventListener_1 = require("./eventListener");
function isDragStartEvent(event) {
    return event.type === 'dragstart';
}
function sendMessage(iframe, data) {
    var contentWindow = iframe.contentWindow;
    if (contentWindow) {
        contentWindow.postMessage(data, '*');
    }
}
function sendMessageToElement(element, data) {
    var iframes = element.getElementsByTagName('iframe');
    if (iframes && iframes.length) {
        var iframe = iframes[0];
        sendMessage(iframe, data);
    }
}
function useDraggable(_a) {
    var data = _a.data, enabled = _a.enabled, ref = _a.ref;
    var element = ref ? ref.current : null;
    var dragStartHandler = react_1.useCallback(function (event) {
        if (event && isDragStartEvent(event) && event.dataTransfer) {
            var dataTransfer_1 = event.dataTransfer;
            Object.entries(data).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                dataTransfer_1.setData(key, value);
            });
            dataTransfer_1.effectAllowed = 'copy';
            if (element) {
                var images = element.getElementsByTagName('img');
                if (images && images.length) {
                    var dragImage = images[0];
                    dataTransfer_1.setDragImage(dragImage, 10, 10);
                }
            }
        }
    }, [data, element]);
    var dragEndHandler = react_1.useCallback(function () {
        var skyscrapers = document.getElementsByClassName('banners__right-skyscraper');
        if (skyscrapers && skyscrapers.length) {
            var skyscraperright = skyscrapers[0];
            if (skyscraperright) {
                sendMessageToElement(skyscraperright, data);
            }
        }
    }, [data]);
    eventListener_1.useEventListener('dragstart', dragStartHandler, element, enabled);
    eventListener_1.useEventListener('dragend', dragEndHandler, element, enabled);
    return enabled;
}
exports.useDraggable = useDraggable;
